import React from 'react';
import PropTypes from 'prop-types';
import CustomPortal from '../../commonComponents/CustomPortal';
import CustomButton from '../../commonComponents/buttons';
import { FormControl } from '../../commonComponents/FormControl';
import { MaxValueInput } from './MaxValueInput';
import { usePromotionForm } from './hooks/usePromotionForm';
import { MAX_PROMOTION_VALUE, promotionPropType } from './constants';
import { Colors } from '../../../themes/colors';

const maxValueLabelStyle = {
  fontSize: 16,
  fontWeight: 700,
  whiteSpace: 'nowrap',
};

export const PromotionFormModal = ({
  mode,
  promotion,
  onClose,
  onRequestDisable,
}) => {
  const {
    isEdit,
    name,
    setName,
    maxValue,
    setMaxValue,
    errorMessage,
    isValid,
    isSaving,
    handleSubmit,
  } = usePromotionForm({ mode, promotion, onClose });

  return (
    <CustomPortal
      title={isEdit ? 'Edit program' : 'Create program'}
      cancelText={isEdit ? 'Cancel' : 'Close'}
      submitText={isEdit ? 'Save' : 'Add'}
      submitPressed={handleSubmit}
      cancelPressed={onClose}
      rightButtonDisabled={!isValid || isSaving}
    >
      <div style={{ width: '100%', maxWidth: 420, margin: '0 auto' }}>
        <FormControl
          label="Promotion Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter Name"
          style={{ maxWidth: '100%' }}
        />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            marginTop: 20,
            marginBottom: 40,
            width: '100%',
          }}
        >
          <b style={maxValueLabelStyle}>Max Value</b>
          <MaxValueInput
            value={maxValue}
            onChange={setMaxValue}
            max={MAX_PROMOTION_VALUE}
            placeholder="0.00"
          />
        </div>

        {isEdit && (
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
            <CustomButton
              name="Disable Promotion"
              color={Colors.warning_700}
              width={200}
              class_name="button"
              click={() => onRequestDisable(promotion)}
            />
          </div>
        )}

        {errorMessage && (
          <p style={{ color: Colors.error_500, textAlign: 'center', marginTop: 8 }}>
            {errorMessage}
          </p>
        )}
      </div>
    </CustomPortal>
  );
};

PromotionFormModal.propTypes = {
  mode: PropTypes.oneOf(['create', 'edit']).isRequired,
  promotion: promotionPropType,
  onClose: PropTypes.func.isRequired,
  onRequestDisable: PropTypes.func,
};

PromotionFormModal.defaultProps = {
  promotion: null,
  onRequestDisable: undefined,
};
